<template>
  <div>
    <player-profile-dialog
      v-if="showProfile"
      :user="user"
      :game="game"
      :visible="showProfile"
      :closeAction="function() {showProfile=false}"
    ></player-profile-dialog>
    <v-row class="align-center" no-gutters>
      <v-col style="width:2em;max-width:2em;" v-if="displayIcon" class="text-center" :align-self="playerAvatarColSelfAlign">
        <player-avatar :user="user"></player-avatar>
      </v-col>
      <v-col @click.stop="onNameClicked()">
        <span v-if="isWildcard">{{$t('common.wildcard')}}</span>
        <span v-if="isDeletedUser"><i>{{$t('common.deleted-player')}}</i></span>
        <span v-else style="word-break:break-all;">{{username}}<verified-sign v-if="user.verified" />
        <twitch-sign v-if="renderSocialiteIcons && extAccount('twitch')" driver="twitch"/><twitch-sign v-if="renderSocialiteIcons && extAccount('youtube')" driver="youtube"/></span>
        <sup>
            <v-icon x-small v-if="user.insta_handle">mdi-instagram</v-icon>
            <v-icon x-small v-if="user.twitter_handle">mdi-twitter</v-icon>
        </sup>
        <br v-if="user.email" />
        <span v-if="user.email" class="caption text--secondary">{{user.email}}</span>
        <slot></slot>
      </v-col>
      <v-col v-if="showActions" cols="auto" class="text-right">
        <span><slot name="beforeActionButtons"></slot></span>
        <actions-button
          buttonClasses="secondary v-size--large"
          :entity="user"
          :actions="mergedActions"
          :menuSubheader="user.name"
          :disabled="actionsDisabled"
        />
      </v-col>
    </v-row>
    <confirm-dialog
      v-if="showConfirmDeletionDialog"
      :visible="showConfirmDeletionDialog"
      :entity="user"
      :title="'Freundschaft beenden'"
      :text="confirmDeletionDialogText"
      confirmButtonClasses="error"
      :closeAction="function() {showConfirmDeletionDialog = false;}"
      :confirmAction="confirmUserDeletion"
    ></confirm-dialog>
  </div>
</template>

<script>
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";
import PlayerProfileDialog from "@/widgets/PlayerProfileDialog";
import ActionsButton from "@/widgets/ActionsButton";
import ConfirmDialog from "@/widgets/ConfirmDialog";
import VerifiedSign from "@/widgets/VerifiedSign";
import PlayerAvatar from "@/widgets/PlayerAvatar";
import TwitchSign from './TwitchSign.vue';

export default {
  name: "UserWidget",
  components: {
    PlayerProfileDialog,
    ConfirmDialog,
    ActionsButton,
    VerifiedSign,
    PlayerAvatar,
    TwitchSign,
  },
  props: {
    displayIcon: {
      type: Boolean,
      default: true
    },
    showButtons: {
      type: Boolean,
      default: true
    },
    user: {
      type: Object,
      required: true
    },
    game: { // just passed through for the player details dialog
      type: Object,
      required: false
    },
    actions: {
      type: Object,
      required: false
    },
    showDefaultActions: {
      type: Array,
      default: undefined
    },
    actionsDisabled: {
      type: Boolean,
      default: false
    },
    playerAvatarColSelfAlign: {
      type: String,
      default: 'center'
    },
    renderSocialiteIcons: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    var self = this;
    return {
      showProfile: false,
      defaultActions: {
        details: {
          icon: "mdi-open-in-app",
          classes: "primary",
          label: this.$t('userWidget.open-profile'),
          action: function() { // (user)
            self.showProfile = true;
          }
        },
        removeFriend: {
          icon: "mdi-account-remove",
          label: this.$t('userWidget.end-friendship'),
          action: function(user) {
            self.confirmDeletionDialogText = 'Willst Du die Freundschaft zu "' + user.name + '" wirklich beenden?';
            self.showConfirmDeletionDialog = true;
          }
        }
      },
      showConfirmDeletionDialog: false,
      confirmDeletionDialogText: '',
    };
  },
  computed: {
    username(){
      if(this.game?.game === 'fifa-pro-clubs-22' || this.game?.game === 'fifa-pro-clubs'){
        return this.user?.onlineIds[this.game?.platform]?.onlineId ?? this.user?.name
      }
      return this.user?.name
    },
    showActions: function() {
      return this.showButtons && Object.keys(this.mergedActions).length > 0 && !this.isWildcard && !this.isDeletedUser;
    },
    isWildcard: function() {
      return this.user.name == '*';
    },
    isDeletedUser: function() {
      return this.user.name.indexOf('$deleted$') === 0;
    },
    mergedActions: function() {
      if (!this.showDefaultActions) {
        // Use all default actions
        return Object.assign({}, this.defaultActions, this.actions);
      } else {
        let ret = {}
        this.showDefaultActions.forEach((actionKey) => {
          if (this.defaultActions[actionKey]) {
            ret[actionKey] = this.defaultActions[actionKey]
          }
        });
        return Object.assign(ret, this.actions);
      }
    },
  },
  mounted() {},
  methods: {
    onNameClicked() {
      if (this.showButtons && !this.isWildcard && !this.isDeletedUser) {
        this.showProfile = true
      }
    },
    confirmUserDeletion(user) {
      console.log('User deletion confirmed', user)
      this.$api.removeFriendship(user.uid).then(() => {
        this.$eventBus.$emit(EVENT_REFRESH_DATA);
      })
    },
    extAccount: function(driver) {
      if (!this.user.externalAccounts) {
        return undefined
      }
      return this.user.externalAccounts.find(function (e) {
        return e.driver == driver
      })
    },
  }
};
</script>
